const SITES_QUERY_PARAM = "sites";

export function getSelectedSitesQueryParam(): string {
  return SITES_QUERY_PARAM;
}

export function parseSelectedSitesFromSearch(search: string): string[] {
  const params = new URLSearchParams(search);
  return params
    .getAll(SITES_QUERY_PARAM)
    .map((value) => value.trim())
    .filter(Boolean);
}

export function replaceSelectedSitesInParams(
  params: URLSearchParams,
  sites: string[]
): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete(SITES_QUERY_PARAM);
  sites.forEach((site) => next.append(SITES_QUERY_PARAM, site));
  return next;
}

export function areSelectedSitesEqual(
  left: string[],
  right: string[]
): boolean {
  return (
    left.length === right.length &&
    left.every((site, index) => site === right[index])
  );
}
